import { WSForm, WSSelect } from "@wingspanhq/fe-component-library";
import { AttributeDefinition } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

import { AcceptedValuesResources, getEnumValues } from "./helpers";

type Props = {
  definition: AttributeDefinition;
  resources: AcceptedValuesResources;
  disabled?: boolean;
};

export const FieldEnum: React.FC<Props> = props => {
  const acceptedValues = useMemo(
    () => getEnumValues(props.definition, props.resources),
    [props.definition, props.resources]
  );

  if (!acceptedValues.length) {
    return null;
  }

  return (
    <WSForm.Field
      name={props.definition.key}
      component={WSSelect}
      componentProps={{
        label: props.definition.name,
        helperText: props.definition.description,
        required: props.definition.isRequired,
        disabled: props.disabled,
        options: acceptedValues
          .filter(Boolean)
          .map(value => ({ value, label: value }))
      }}
    />
  );
};
